<template>

<div class="contendor_flecha">
     <div class="centrar_flechas">
             <router-link  :to="'/'+nombreModulo+'/'+(unipage-1)" class="flechas flecha-izq " style="text-decoration:none">
                <a href="#"><img src="@/assets/imagenes_compartidas/Voltar.svg"  alt="" style="text-decoration:none"></a>  
                <!-- <span>Voltar</span>  -->
  </router-link>
      </div>
       <div class="centrar_flechas_izq">
   <router-link  :to="'/'+nombreModulo+'/'+(Number(unipage)+1)" class="flechas flecha-der " style="text-decoration:none">
                <a href="#"><img src="@/assets/imagenes_compartidas/Avanzar.svg"  alt="" style="text-decoration:none"></a>  
                <!-- <span>Avancar</span>  -->
  </router-link>
    </div>
</div>
</template>

<script>

    export default {
        props: {
            nombreModulo: {
                required: true
            },
            unipage: ''
        },
        data() {
            return {
            }
        },
        comnputed:{
            unipage() {
               return this.$route.params.unipage
            }
        }
    
    }


</script>
<style lang="scss" scoped>
    @import '../sass/globals';


    @media only screen and (min-width: 460px){ 



a.flechas {
    margin: 5px;
    img{
        width: 60px;
        height: 60px;
    }
}

    }

.contendor_flecha{
width: 100%;
    height: 8%;
    display: grid;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    // background: seagreen;
    text-decoration: none;
    position: absolute;
    z-index: 99;
    -ms-flex-line-pack: center;
    align-content: center;
    cursor: pointer;
    grid-template-columns: repeat(2, 50%);
    top: 44%;


.centrar_flechas{
width: 100%;
height: 100%;
// background: red;
}

.centrar_flechas_izq{
        width: 100%;
height: 100%;
// background: black;
display: flex;
justify-content: flex-end;
}
}


.flechas {
    margin: 5px;
    img{
        width: 30px;
        height: 32px;
    }
}
</style>
